import { useState } from "react";
import {
  User,
  Phone,
  Globe,
  Shield,
  LogOut,
  ChevronRight,
  Package,
  List,
  TrendingUp,
  HelpCircle,
  MessageCircle
} from "lucide-react";
import { motion } from "framer-motion";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import cacheStorage from "../../../utils/cacheStorage";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CourierProfile({
                                 navigateTo,
                                 onLogout
                               }) {
  const {
    language,
    setLanguage,
    t,
    data
  } = useCourierLanguage();

  const [userPicture] = useState(() => cacheStorage.getItem('user_picture') || null);

  const profileInfo = {
    name: data.courierName,
    phone: data.courierPhone,
    joinDate: data.courierJoinDate,
    totalDeliveries: 1247,
    rating: 4.8
  };
  const handleLanguageSwitch = () => {
    const langs = ["en", "aze", "ru"];
    const currentIndex = langs.indexOf(language);
    setLanguage(langs[(currentIndex + 1) % langs.length]);
  };
  const languageLabels = {
    en: "English",
    aze: "Azərbaycanca",
    ru: "Русский"
  };
  const settingsItems = [{
    icon: Globe,
    label: t.language,
    value: languageLabels[language],
    action: handleLanguageSwitch
  }, {
    icon: Shield,
    label: t.privacySecurity,
    value: "",
    action: () => navigateTo("privacy-security")
  }, {
    icon: HelpCircle,
    label: t.help,
    value: "",
    action: () => navigateTo("help")
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsx("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4 pb-24",
      children: /*#__PURE__*/_jsx("h1", {
        className: "text-2xl font-bold",
        children: t.profile
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-4 neg-mt-16",
      children: [/*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        className: "bg-white rounded-2xl p-6 shadow-md mb-6",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-4 mb-4",
          children: [/*#__PURE__*/_jsx("div", {
            className: "w-20 h-20 rounded-full bg-gradient-to-br from---2D58AD- to---71A4F4- flex items-center justify-center text-white font-bold text-3xl shadow-lg overflow-hidden",
            children: userPicture
                ? /*#__PURE__*/_jsx("img", {
                  src: userPicture,
                  alt: profileInfo.name,
                  style: { width: "100%", height: "100%", objectFit: "cover" }
                })
                : (profileInfo.name ? profileInfo.name.charAt(0).toUpperCase() : "?")
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-1",
            children: [/*#__PURE__*/_jsx("h2", {
              className: "text-xl font-bold text---000080- mb-1",
              children: profileInfo.name
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-sm text-neg-708094-",
              children: [t.courierSince, " ", profileInfo.joinDate]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-2 mt-2",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex items-center gap-1",
                children: [/*#__PURE__*/_jsx(Package, {
                  className: "w-4 h-4 text-neg-2D58AD-"
                }), /*#__PURE__*/_jsx("span", {
                  className: "text-sm font-semibold text---000080-",
                  children: profileInfo.totalDeliveries
                })]
              }), /*#__PURE__*/_jsx("span", {
                className: "text-neg-708094-",
                children: "\u2022"
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex items-center gap-1",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "text---F59E0B-",
                  children: "\u2605"
                }), /*#__PURE__*/_jsx("span", {
                  className: "text-sm font-semibold text---000080-",
                  children: profileInfo.rating
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-3 mt-2",
          children: [/*#__PURE__*/_jsx("div", {
            className: "w-10 h-10 bg-neg-2D58AD--10 rounded-xl flex items-center justify-center",
            children: /*#__PURE__*/_jsx(Phone, {
              className: "w-5 h-5 text-neg-2D58AD-"
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "font-bold text---000080-",
              children: t.phone
            }), /*#__PURE__*/_jsx("p", {
              className: "font-semibold text---000080-",
              children: profileInfo.phone
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.1
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-6",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.settings
        }), /*#__PURE__*/_jsx("div", {
          className: "space-y-2",
          children: settingsItems.map((item, index) => /*#__PURE__*/_jsxs("button", {
            onClick: item.action,
            className: "w-full flex items-center justify-between p-3 hover-bg---F5F6FA- rounded-xl transition-colors",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-3",
              children: [/*#__PURE__*/_jsx(item.icon, {
                className: "w-5 h-5 text-neg-708094-"
              }), /*#__PURE__*/_jsx("span", {
                className: "font-medium text---000080-",
                children: item.label
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-2",
              children: [item.value && /*#__PURE__*/_jsx("span", {
                className: "text-sm text-neg-708094-",
                children: item.value
              }), /*#__PURE__*/_jsx(ChevronRight, {
                className: "w-5 h-5 text-neg-708094-"
              })]
            })]
          }, index))
        })]
      }), /*#__PURE__*/_jsxs(motion.button, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.2
        },
        onClick: onLogout,
        className: "w-full bg-white rounded-2xl p-5 shadow-md flex items-center justify-center gap-3 text-red-600 font-semibold hover-bg-red-50 transition-colors",
        children: [/*#__PURE__*/_jsx(LogOut, {
          className: "w-5 h-5"
        }), t.logout]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-around max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("dashboard"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Package, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.home
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("packages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(List, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.packages
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("messages"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(MessageCircle, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: "Messages"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("performance"),
          className: "flex flex-col items-center gap-1 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(TrendingUp, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.performance
          })]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: () => navigateTo("profile"),
          className: "flex flex-col items-center gap-1 text-neg-2D58AD-",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-6 h-6"
          }), /*#__PURE__*/_jsx("span", {
            className: "text-xs font-medium",
            children: t.profile
          })]
        })]
      })
    })]
  });
}